const plural: Record<string, string> = {
  exposição: "exposições",
  encerrada: "encerradas",
};

export const plurals = (text: string, value: number) => {
  if (value > 1 && plural[text]) {
    return plural[text];
  }
  return text;
};
